const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const ATHLETE_QUESTIONS_URL = `${BACKEND_URL}/questions`;
export const COACH_QUESTIONS_URL = `${BACKEND_URL}/coach-questions`;
export const SAVE_USER_URL = `${BACKEND_URL}/save-user`;
export const IMAGE_PATH_URL = `${BACKEND_URL}/get-image-path`;
export const MEAL_PLAN_URL = `${BACKEND_URL}/meal-plan`;
